import { useMemo } from "react";

export const useResolvedEntryMap = ({
  mafiaEntryTable = [],
  selectedDna,
  min,
  max,
}) => {
  return useMemo(() => {
    if (!selectedDna || mafiaEntryTable.length === 0) {
      return { values: {}, disabledFields: [], highlightedFields: [] };
    }

    const selectedDnaNum = String(selectedDna?.DNANum ?? "").trim();
    const lower = min !== "" ? parseFloat(min) : null;
    const upper = max !== "" ? parseFloat(max) : null;

    const values = {};
    const disabled = [];
    const highlight = [];

    for (const row of mafiaEntryTable) {
      const cell = row?.CellNum != null ? String(row.CellNum) : "";
      if (!cell) continue;

      const dnaMatch = String(row?.DNANum ?? "").trim() === selectedDnaNum;
      if (!dnaMatch) continue;

      const raw = row?.Value != null ? String(row.Value) : "";
      const value = raw.trim();
      if (value.length === 0) continue;

      const name = `txtDynamic${cell}`;
      values[name] = value;
      disabled.push(name);

      if (value === "-777") {
        values[name] = "PASS";
      } else if (value === "-999") {
        values[name] = "FAIL";
        highlight.push(name);
      } else {
        const valNum = parseFloat(value);
        if (
          !isNaN(valNum) &&
          ((lower !== null && valNum < lower) ||
            (upper !== null && valNum > upper))
        ) {
          highlight.push(name);
        }
      }
    }

    return { values, disabledFields: disabled, highlightedFields: highlight };
  }, [mafiaEntryTable, selectedDna, min, max]);
};